module.exports = __webpack_public_path__ + "img/tool_pen_out.1545aaa8.png";